import { useState, useEffect } from "react";
import { db } from "@healthdesk/shared-services";

const DEFAULTS = {
  phase2MaxQuestions: 5,
  phase3MaxQuestionsDashboard: 30,
  phase3MaxQuestionsStandalone: 5,
  autoRefreshInterval: 18000,
  ddxStabilityRequired: 2,
  similarityThreshold: 0.6,
  symptomDetailsLlmTimeoutMs: 8000,
};

const DOC_PATH = "systemConfig/symptomCheckerV4Phases";

let cachedV4Config = null;

/**
 * Fetches Symptom Checker 4 phase configuration from Firestore with hardcoded defaults.
 * Caches in-memory so subsequent mounts do not re-fetch.
 */
export function useSymptomCheckV4Config() {
  const [config, setConfig] = useState(cachedV4Config || DEFAULTS);
  const [loading, setLoading] = useState(!cachedV4Config);

  useEffect(() => {
    if (cachedV4Config) return;
    let cancelled = false;

    db.collection("systemConfig")
      .doc("symptomCheckerV4Phases")
      .get()
      .then((snap) => {
        if (cancelled) return;
        const data = snap.exists ? snap.data() : {};
        const merged = { ...DEFAULTS };
        for (const key of Object.keys(DEFAULTS)) {
          if (data[key] != null) merged[key] = Number(data[key]);
        }
        cachedV4Config = merged;
        setConfig(merged);
      })
      .catch(() => {
        if (!cancelled) setConfig(DEFAULTS);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, []);

  return { config, loading, DEFAULTS };
}
